import { useQuery } from '../graphql';
import { useTeam } from '../hooks/team';
import { SESSION_STICKY_VIEW_QUERY_OPTIONS } from './viewQuery.utils';

export const STORYBOOK_FINALYTIC_CONNECTION_QUERY_KEY = 'finalytic-connection';

export type FinalyticConnection = {
  id: string;
  appId: string | null;
  name: string | null;
};

type FinalyticConnectionQueryData = {
  finalyticConnection: FinalyticConnection | undefined;
};

export function useFinalyticConnectionQuery() {
  const [{ id: teamId }] = useTeam();

  const queryData = useQuery<FinalyticConnectionQueryData, { teamId: string }>(
    (q, args) => {
      const finalyticConnection =
        q
          .connection({
            where: {
              tenantId: { _eq: args.teamId },
              appId: { _eq: 'finalytic' },
            },
            limit: 1,
            order_by: [{ appId: 'asc_nulls_first' }],
          })
          .map<FinalyticConnection>((connection) => ({
            id: connection.id,
            appId: connection.appId,
            name: connection.name,
          }))[0] || undefined;

      return {
        finalyticConnection,
      };
    },
    {
      keepPreviousData: true,
      queryKey: ['connections', 'finalytic'],
      storybookQueryKey: STORYBOOK_FINALYTIC_CONNECTION_QUERY_KEY,
      skip: !teamId,
      variables: {
        teamId: teamId || '',
      },
      ...SESSION_STICKY_VIEW_QUERY_OPTIONS,
    }
  );

  return {
    finalyticConnection: queryData.data?.finalyticConnection,
    finalyticConnectionId: queryData.data?.finalyticConnection?.id,
    loading: queryData.isLoading,
    error: queryData.error,
    refetch: queryData.refetch,
    queryKey: queryData.queryKey,
  };
}
